import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class SaveChangesModal extends Component {
  constructor(props) {
    super(props);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
  }

  handleSaveClick() {
    const {values} = this.props;

    this.savePartInfo(values);
    this.props.togglePartFormConfirmation(false);
  }

  savePartInfo(values) {
    if (!values.company) {
      this.props.savePartMasterInfo(values);
      return;
    }

    this.props.editPartMasterInfo(values.partCode, values);
  }

  handleCancelClick() {
    this.props.togglePartFormConfirmation(false);
  }

  renderMessages() {
    const {confirmationMessages} = this.props;

    return (
      <ul>
        {confirmationMessages.map((message, index) => (<li key={index}>{message}</li>))}
      </ul>
    );
  }

  render() {
    const {open, trigger} = this.props;

    return (
      <Modal
        size='tiny'
        open={open}
        className='parts-master'
        trigger={trigger}
      >
        <Modal.Content>
          <strong>¿Desea continuar con el cambio?</strong>
          {this.renderMessages()}
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={this.handleCancelClick}>Cancelar</Button>
          <Button primary onClick={this.handleSaveClick}>Guardar</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'values': state.partsMaster.values,
    'confirmationMessages': state.partsMaster.confirmationMessages,
    'openConfirmation': state.partsMaster.openConfirmation,
  };
};

const {
  togglePartFormConfirmation,
  editPartMasterInfo,
  savePartMasterInfo,
} = Actions;

export default connect(mapStateToProps, {
  togglePartFormConfirmation,
  editPartMasterInfo,
  savePartMasterInfo,
})(SaveChangesModal);
